import React, { useEffect, useState } from 'react';
import {
  UploadMarketplace,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/UploadMarketplace';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { translations } from 'src/constants/translations';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { IMarketplaceTilesLocationSubValue, IMarketplaceTilesLocationValue } from 'src/typings/marketplace';
import { IOSSwitch } from 'src/components/SwitchIos';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import { readURL } from 'src/helpers';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import {
  useStyles,
} from './styles';

interface IProps {
  item: IMarketplaceTilesLocationValue;
  lang: string;
  onChange: (item: IMarketplaceTilesLocationValue) => void,
}
export const TileLocationMetroStation: React.FC<IProps> = ({ item, lang, onChange }) => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const [image, setImage] = useState<string | null>(item.iconFileUri?.fileUrl || null);
  const [imageWalking, setImageWalking] = useState<string | null>(item.walkingDistance?.iconFileUri?.fileUrl || null);
  const [imageDriving, setImageDriving] = useState<string | null>(item.drivingDistance?.iconFileUri?.fileUrl || null);
  const [options, setOptions] = React.useState<IDevelopmentSpecificationPropChange<boolean>[]>([]);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);

  useEffect(() => {
    setOptions([{
      label: 'Enabled',
      value: true,
    }, {
      label: 'Disabled',
      value: false,
    }]);
  }, [item]);

  const rocketChange = (state: boolean) => {
    onChange({ ...item, isActive: state });
    setRocketState(state);
  };

  const updateDistance = (
    field: 'walkingDistance' | 'drivingDistance',
    value: IMarketplaceTilesLocationSubValue,
  ) => onChange({ ...item, [field]: value });

  return (
    <SubGroupWrapper
      name={item.property?.translates?.[lang] || item.property?.systemName || ''}
      rocketState={rocketState}
      customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
      onRocket={rocketChange}
    >
      <div className={styles.tileLocationMetroStationWrapper}>
        <UploadMarketplace
          register={() => {}}
          registerName=""
          image={image}
          onUpload={async (file, response) => {
            onChange({ ...item, iconFileUri: response.data[0] });
            const base64: string = await readURL(file);
            if (base64) {
              setImage(base64);
            }
          }}
        />
        <BoxFormTextField
          label={translations.prefix}
          name="prefix"
          defaultValue={item.prefix?.[lang]}
          onChange={(event) => {
            onChange(updateTranslatedField(item, 'prefix', lang, event.target.value));
          }}
        />
        <BoxFormTextField
          label={translations.suffix}
          name="suffix"
          defaultValue={item.suffix?.[lang]}
          onChange={(event) => {
            onChange(updateTranslatedField(item, 'suffix', lang, event.target.value));
          }}
        />
        <div className={styles.optionSwitch}>
          {translations.walkingDistance}
          <IOSSwitch
            defaultChecked={!!item.walkingDistance?.isActive}
            onChange={(e: any) => {
              if (item.walkingDistance) {
                updateDistance('walkingDistance', { ...item.walkingDistance, isActive: e.target.checked });
              }
            }}
          />
        </div>
        <UploadMarketplace
          register={() => {}}
          registerName=""
          image={imageWalking}
          onUpload={async (file, response) => {
            if (item.walkingDistance) {
              updateDistance('walkingDistance', { ...item.walkingDistance, iconFileUri: response.data[0] });
              const base64: string = await readURL(file);
              if (base64) {
                setImageWalking(base64);
              }
            }
          }}
        />
        <div className={styles.uom}>
          <BoxFormTextField
            label={translations.uom}
            name="uom"
            defaultValue={item.walkingDistance?.uomText?.[lang]}
            onChange={(event) => {
              if (item.walkingDistance) {
                updateDistance('walkingDistance', updateTranslatedField(item.walkingDistance, 'uomText', lang, event.target.value));
              }
            }}
          />
        </div>
        <div className={styles.optionSwitch}>
          {translations.drivingDistance}
          <IOSSwitch
            defaultChecked={!!item.drivingDistance?.isActive}
            onChange={(e: any) => {
              if (item.drivingDistance) {
                updateDistance('drivingDistance', { ...item.drivingDistance, isActive: e.target.checked });
              }
            }}
          />
        </div>
        <UploadMarketplace
          register={() => {}}
          registerName=""
          image={imageDriving}
          onUpload={async (file, response) => {
            if (item.drivingDistance) {
              updateDistance('drivingDistance', { ...item.drivingDistance, iconFileUri: response.data[0] });
              const base64: string = await readURL(file);
              if (base64) {
                setImageDriving(base64);
              }
            }
          }}
        />
        <div className={styles.uom}>
          <BoxFormTextField
            label={translations.uom}
            name="uom"
            defaultValue={item.drivingDistance?.uomText?.[lang]}
            onChange={(event) => {
              if (item.drivingDistance) {
                updateDistance('drivingDistance', updateTranslatedField(item.drivingDistance, 'uomText', lang, event.target.value));
              }
            }}
          />
        </div>
        <div className={styles.shorterDistanceOnly}>
          <BoxFormAutocomplete
            label={translations.shorterDistanceOnly}
            name="property"
            defaultValue={{ label: item.isShorterDistanceOnly ? 'Enabled' : 'Disabled', value: item.isShorterDistanceOnly }}
            onChange={(event: IDevelopmentSpecificationPropChange<boolean>) => {
              onChange({ ...item, isShorterDistanceOnly: event.value });
            }}
            options={options}
          />
        </div>
      </div>
    </SubGroupWrapper>
  );
};
